/**
 * 跨子域共享 Cookie 时使用的父域。
 * 仅在 digen.ai 及其子域生效；Amplify 预览、localhost 等返回 undefined（host-only）。
 */
export function getSharedCookieDomain(hostname?: string): string | undefined {
  const host =
    hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')

  if (!host) return undefined

  if (host === 'digen.ai' || host.endsWith('.digen.ai')) {
    return '.digen.ai'
  }

  return undefined
}

export function isLocalDevHost(host: string): boolean {
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host.startsWith('192.168.')
  )
}

export function isLocalDev(): boolean {
  if (typeof window === 'undefined') return false
  return isLocalDevHost(window.location.hostname)
}
